import { createContext } from 'react'

const initialState = { user: null, updateAction: () => null, submitDisabled: false, isProfile: false }

export const AccountContext = createContext(initialState)
